import FlashMessage from "~/components/FlashMessage";
import { Flash as TFlash } from "~/entities/flash/types";

/** @deprecated Use Alert instead */
const Flash: React.FC<{ flashes: TFlash[] | null }> = ({ flashes }) => {
  if (!flashes?.length) return null;

  return (
    <>
      {flashes.map((flash, index) => (
        <FlashMessage
          key={`flash-${index}`}
          kind={flash.kind}
          message={flash.message}
        />
      ))}
    </>
  );
};

export default Flash;
